import React from "react";
import { useAuth } from "../../../../context/AuthContext";
import { ClinicStockOrdersView } from "./ClinicStockOrder";

export const StockOrdersView: React.FC = () => {
  const { user } = useAuth();
  return (
    <>
      { user?.role.toLocaleLowerCase() === "clinic" ? (
        <ClinicStockOrdersView />
      ) : (
        null
      )}
    </>
  );
};